import React from "react";
import Lottie from "react-lottie";
import "./display-lottie.scss";

// Custom Character Animation SVG in About Section
const DisplayLottie = ({ animationData }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };
  return (
    <div fallback="Loading...." className="display-lottie-container">
      <Lottie
        style={{
          // width: "90%",
          // height: "92%",
          marginTop: "-1.4rem",
        }}
        options={defaultOptions}
        isClickToPauseDisabled={true}
      />
    </div>
  );
};

export default DisplayLottie;
